export default __webpack_public_path__ + "static/media/shovel-1.bf2f6a2a.png";